// noinspection JSUnusedGlobalSymbols
export enum TyroPayRequestStatus {
    PROCESSING = <any>"PROCESSING",
    SUCCESS = <any>"SUCCESS",
    FAILED = <any>"FAILED"
}

// noinspection JSUnusedGlobalSymbols
export class TyroPayRequest {
    capture: {
        method: string;
    };
    gatewayCode: string;
    isLive: boolean;
    origin: {
        orderId: string;
    };
    status: TyroPayRequestStatus;
    supportedNetworks: string[];
    threeDSecure: {
        status: string;
    };
    total: {
        amount: number;
        currency: string;
    };
    vgsRoutePrefix: string;
}

// noinspection JSUnusedGlobalSymbols
export enum TyroPayRequestErrorType {
    CLIENT_VALIDATION_ERROR = <any>"CLIENT_VALIDATION_ERROR",
    SERVER_VALIDATION_ERROR = <any>"SERVER_VALIDATION_ERROR",
    CARD_ERROR = <any>"CARD_ERROR",
    SERVER_ERROR = <any>"SERVER_ERROR",
    UNKNOWN_ERROR = <any>"UNKNOWN_ERROR"
}

export class TyroPayRequestError {
    type: TyroPayRequestErrorType;
    errorMessage: string;
    errorCode: string;
    gatewayCode: string;
}


// WEBPACK FOOTER //
// ./src/app/payment/tyro.ts